import { last, map } from "lodash";
import {
  CogIcon,
  LockIcon,
  PaletteIcon,
  TabletIcon,
  UnplugIcon,
} from "lucide-react";
import { FC, ReactElement } from "react";
import { NavLink, useLocation } from "react-router";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

type Route = {
  title: string;
  url: string;
  icon: ReactElement;
  disabled: boolean;
};

const routes: Route[] = [
  {
    title: "Styling",
    url: "styling",
    icon: <PaletteIcon />,
    disabled: true,
  },
  {
    title: "Login",
    url: "login",
    icon: <LockIcon />,
    disabled: true,
  },
  {
    title: "Content",
    url: "content",
    icon: <TabletIcon />,
    disabled: false,
  },
  {
    title: "Integrations",
    url: "integrations",
    icon: <UnplugIcon />,
    disabled: false,
  },
  {
    title: "Advanced",
    url: "advanced",
    icon: <CogIcon />,
    disabled: false,
  },
];

type ButtonProps = { route: Route; isActive?: boolean };

const ButtonDisabled: FC<ButtonProps> = ({ route }) => (
  <SidebarMenuButton variant="disabled" asChild disabled>
    <span>
      {route.icon} {route.title}
    </span>
  </SidebarMenuButton>
);

const ButtonEnabled: FC<ButtonProps> = ({ route, isActive }) => (
  <SidebarMenuButton variant="default" asChild isActive={isActive}>
    <NavLink to={route.url}>
      {route.icon} {route.title}
    </NavLink>
  </SidebarMenuButton>
);

export const CMSSidebar = () => {
  const location = useLocation();
  const path = last(location.pathname.split("/").filter(Boolean));

  return (
    <Sidebar collapsible="none" className="bg-white">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Web Experience</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {map(routes, (route, index) => (
                <SidebarMenuItem key={index}>
                  {route.disabled ? (
                    <ButtonDisabled route={route} />
                  ) : (
                    <ButtonEnabled
                      route={route}
                      isActive={path === route.url}
                    />
                  )}
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};
